'use strict';

require('setimmediate');
var OCL = require('openchemlib');

require('./extend')(OCL);
module.exports = OCL;


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/index.js
// module id = 59
// module chunks = 0